import { useEffect } from 'react';
import HeroBanner from '@/pages/home/components/HeroBanner';
import StatsBanner from '@/pages/home/components/StatsBanner';
import HotRecommendations from '@/pages/home/components/HotRecommendations';
import LatestUpdates from '@/pages/home/components/LatestUpdates';
import CategoryNav from '@/pages/home/components/CategoryNav';
import Testimonials from '@/pages/home/components/Testimonials';
import CTASection from '@/pages/home/components/CTASection';

export default function Home() {
  useEffect(() => {
    const websiteScript = document.createElement('script');
    websiteScript.type = 'application/ld+json';
    websiteScript.innerHTML = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '虚空韩漫网',
      url: 'http://nh5688.com/',
      description: '虚空韩漫网为您提供海量韩漫在线阅读服务，完全免费的韩国漫画、无删减下拉式韩漫大全。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'http://nh5688.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    });
    document.head.appendChild(websiteScript);

    const webpageScript = document.createElement('script');
    webpageScript.type = 'application/ld+json';
    webpageScript.innerHTML = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '虚空韩漫网-韩漫在线阅读_免费的韩国漫画_无删减下拉式韩漫大全',
      description: '虚空韩漫网为您提供海量韩漫在线阅读服务，完全免费的韩国漫画、无删减下拉式韩漫大全。',
      url: 'http://nh5688.com/',
      isPartOf: {
        '@type': 'WebSite',
        name: '虚空韩漫网',
        url: 'http://nh5688.com/',
      },
    });
    document.head.appendChild(webpageScript);

    return () => {
      document.head.removeChild(websiteScript);
      document.head.removeChild(webpageScript);
    };
  }, []);

  return (
    <article>
      <HeroBanner />
      <StatsBanner />
      <HotRecommendations />
      <LatestUpdates />
      <CategoryNav />
      <Testimonials />
      <CTASection />
    </article>
  );
}